<template>
  <div>
    <el-form-item v-if="isMultiLine" label="题干" class="exr-form-subject-list">
      <div class="exr-subject-wrap" v-for="(value, key) in options" :key="key">
        <div class="exr-item">
          <el-input v-model="value.text"></el-input>
          <PinyinInput v-model="value.pinyin" v-if="config.subjectPinyin" :text="value.text"></PinyinInput>
          <el-input v-model="value.audio" class="exr-item-audio" title="录音"></el-input>
          <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
          <el-button icon="el-icon-plus" tabindex="-1" @click="addItem(key)"></el-button>
        </div>
        <PinyinPreview v-if="config.subjectPinyin" :text="value.text" :pinyin="value.pinyin" popover></PinyinPreview>
      </div>
    </el-form-item>
    <el-form-item v-else label="题干">
      <div class="exr-form-subject">
        <el-input v-model="form.subject"></el-input>
        <PinyinInput v-model="form.subjectPinyin" v-if="config.subjectPinyin" :text="form.subject"></PinyinInput>
      </div>
      <PinyinPreview v-if="config.subjectPinyin" :text="form.subject" :pinyin="form.subjectPinyin" popover></PinyinPreview>
    </el-form-item>
    <el-form-item label="驰声语音">
      <el-input v-model="form.subjectChivox" type="textarea" :autosize="{minRows:1}" resize="none"></el-input>
    </el-form-item>
    <el-form-item label="图片" v-if="config.image">
      <ImageInput v-model="form.image" :desc.sync="form.imageDesc"></ImageInput>
    </el-form-item>
    <el-form-item label="音频">
      <FileInput v-model="form.audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="答案" v-if="config.mode === 0">
      <FileInput v-model="form.answerAudio" accept="audio/*"></FileInput>
    </el-form-item>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
  import ShowAnswer from "./ShowAnswer"

  export default {
    name: 'LytForm',
    components: {
      PinyinPreview: require('@/components/PinyinPreview').default,
      PinyinInput: require('@/components/PinyinInput').default,
      FileInput: require('@/components/FileInput').default,
      ImageInput: require('@/components/ImageInput').default,
      ShowAnswer
    },
    props: {
      config: {},
      model: {}
    },
    data () {
      return {
        form: Object.assign({}, this.model),
        options: []
      }
    },
    watch: {
      model (val) {
        this.form = Object.assign({}, val)
      }
    },
    computed: {
      isMultiLine () {
        return this.config.subject === 'text' || this.config.subject === 'dialog'
      }
    },
    mounted () {
      if (this.isMultiLine) {
        let opts = []
        if (this.form.subject) {
          let lines = this.form.subject.split(/\r\n|\n/)
          let len = lines.length
          if (this.config.subjectPinyin) {
            let pLines = this.form.subjectPinyin ? this.form.subjectPinyin.split(/\r\n|\n/) : []
            let pLen = pLines.length
            for (let i = 0; i < len; i++) {
              opts.push({
                text: lines[i],
                pinyin: pLen > i ? pLines[i] : '',
                audio: ''
              })
            }
          } else {
            for (let i = 0; i < len; i++) {
              opts.push({
                text: lines[i],
                audio: ''
              })
            }
          }
        }
        this.options = opts
      }
    },
    methods: {
      addItem (index) {
        this.options.splice(index + 1, 0, {})
      },
      removeItem (index) {
        if (this.options.length > 1) {
          this.options.splice(index, 1)
        } else {
          this.options.splice(index, 1, {})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .exr-form-subject{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    > div{
      flex: 1;
      margin-left: 8px;
      min-width: 300px;
    }
  }
  .exr-flex-row{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    > div{
      flex: 1;
      margin-left: 8px;
    }
  }
  .exr-form-subject-list{
    margin-bottom: 20px;
    .exr-item{
      display: flex;
      > .el-radio{
        margin-right: 0;
      }
      > .el-input{
        flex: 2;
        + .el-input {
          margin: 0 6px;
        }
      }
      > .exr-item-audio{
        flex: 1;
      }
      > .el-button{
        width: 40px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        text-align: center;
      }
    }
    .exr-subject-wrap + .exr-subject-wrap{
      margin-top: 12px;
    }
  }
</style>
